import fetchJsonp from "fetch-jsonp";

type fetchPostsParams = {
  subreddit: string;
  count: number;
  filter: string;
  after: string;
  time: "all" | "month" | "week" | "day" | "hour";
};

async function fetchPosts(params: fetchPostsParams) {
  const response = await jsonpApi(
    `r/${params.subreddit}/${params.filter}`,
    `after=${params.after}&t=${params.time}`
  );
  const { data } = await response.json();
  console.log({ data });
  return data.children;
}

const imageFileExtensions = ["jpg", "png", "gif", "jpeg", "webp", "bmp"];

const getExtension = (filename: string) =>
  // @ts-ignore
  filename.split(".").pop().toLowerCase();

const isImagePost = (post: any) =>
  imageFileExtensions.includes(getExtension(post.data.url));

export async function fetchImages(params: fetchPostsParams): Promise<any> {
  try {
    const posts = await fetchPosts(params);

    return posts.filter(isImagePost);
  } catch (e) {
    console.log(e);
  }
}

async function jsonpApi(post: string, params: string = "") {
  return fetchJsonp(`https://www.reddit.com/${post}/.json?jsonp=?&${params}`, {
    jsonpCallback: "jsonp",
  });
}
